import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Platform, Pressable, View } from 'react-native'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { colors } from '@ui/colors'
import TileBlur from '@ui/tiles/TileBlur'
import DealsModal from '@order/modals/Deals/DealsModal'
import { useSessionDeal } from 'hooks/useSession'
import Button from '@ui/buttons/Button'
import Typography from '@ui/typography'
import Icon from '@ui/elements/Icon'
import { leadingNone } from '@ui/typography/styles'
import cn from '@ui/utils/cn'
import useAppModes from 'hooks/useAppModes'

export default function DealsSection() {
  const { t } = useTranslation(['customer'])
  const text = 'customer:home.sections.deals'
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const [open, setOpen] = useState(false)
  const activeDeal = useSessionDeal()
  const { isTgbo } = useAppModes()

  const onPress = () => setOpen(true)

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            !activeDeal && (
              <Button
                noninteractive
                animation={animation}
                onPress={onPress}
                size="sm"
                variant="outlined"
                label={t(`${text}.cta`)}
              />
            )
          }
          glassProps={{
            animation,
            image: require('@/images/deals.png'),
            imageWrapperStyle: {
              transform: [
                { rotate: isTgbo ? '-15deg' : '-50deg' },
                {
                  scale: Platform.select({
                    default: isTgbo ? 0.9 : 0.75,
                    web: 0.9,
                  }),
                },
              ],
              transformOrigin: 'bottom right',
            },
            imageStyle: {
              transform: isTgbo
                ? Platform.select({
                    default: [{ translateX: 25 }, { translateY: -50 }],
                    web: [{ translateX: 25 }, { translateY: -50 }],
                  })
                : Platform.select({
                    default: [{ translateX: 260 }, { translateY: -60 }],
                    web: [{ translateX: 200 }, { translateY: -20 }],
                  }),
              transformOrigin: 'top right',
            },
            blurStyle: {
              opacity: 0.75,
              transform: [
                { translateX: 50 },
                { translateY: -150 },
                { scale: Platform.select({ default: 1, web: 1 }) },
                { rotate: '-60deg' },
              ],
            },
          }}
          classNameDesc={cn(isTgbo && 'pr-32')}
        />
        {activeDeal && (
          <View className="absolute bottom-0 left-0 w-full p-8">
            <View
              className={cn(
                'border-text bg-gray-75/50 flex min-h-10 w-max flex-row items-center gap-2 self-start rounded-xl border-2 px-2 py-1 pr-4',
                Platform.OS === 'web' && 'backdrop-blur-xl'
              )}
            >
              <Icon name="circle-check-filled" size={24} color={colors.text} />
              <Typography
                variant="SMB"
                className={cn(leadingNone, 'pr-0')}
                numberOfLines={1}
              >
                {activeDeal.dealName}
              </Typography>
            </View>
          </View>
        )}
      </Pressable>
      <DealsModal open={open} close={() => setOpen(false)} />
    </>
  )
}
